/*
 * The copilot's mount (plan §8): App.js's Layout renders it on side-nav
 * pages. It has no hooks, so it can return null before anything mounts.
 *
 * - With the flag off (or in Prod, copilotConfig) it renders nothing: no
 *   hook runs, no storage, timer or call, and the lazy CopilotRoot chunk is
 *   never fetched. The copilot's code stays out of the main bundle.
 * - With it on, it loads CopilotRoot lazily, inside the error boundary, so
 *   a render error or a chunk that fails to load renders nothing and the
 *   page stays.
 */
import React, { Suspense, lazy } from "react";
import { isCopilotEnabled } from "../copilotConfig";
import CopilotErrorBoundary from "./CopilotErrorBoundary";

const CopilotRoot = lazy(() => import(/* webpackChunkName: "copilot" */ "./CopilotRoot"));

export default function CopilotGate() {
  if (!isCopilotEnabled()) return null;
  return (
    <CopilotErrorBoundary>
      <Suspense fallback={null}>
        <CopilotRoot />
      </Suspense>
    </CopilotErrorBoundary>
  );
}
